import React from "react";
import { makeStyles } from "@mui/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

const useStyles = makeStyles((theme) => ({
  signifierContainer: {
    position: "absolute",
    top: 50,
    left: "50%",
    transform: "translate(-50%, 0)",
    zIndex: 2,
    animation: `$scrollIn 4000ms forwards`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  root: {
    [theme.breakpoints.down("md")]: {
      minWidth: "80vw",
      maxHeight: "20px",
    },
    minWidth: 600,
    minHeight: 60,
    maxHeight: "100px",
    position: "relative",

    left: "50%",
    transform: "translate(-50%, 0)",

    display: "flex",
    alignItems: "center",
  },
  hidden: {
    display: "none",
  },
  title: {
    fontSize: 26,
    animation: "none !important",
  },
  "@keyframes scrollIn": {
    "0%": {
      top: -200,
    },
    "20%": {
      top: 50,
    },
    "80%": {
      top: 50,
    },
    "100%": {
      top: -200,
    },
  },
}));

export default function Signifier(props: {
  showSignifier: boolean;
  setShowSignifier: React.Dispatch<React.SetStateAction<boolean>>;
  message: string;
  error: boolean;
  errorMessage: string;
}) {
  const classes = useStyles();
  const signifierMessage = !props.error
    ? props.message
    : props.errorMessage ?? "Something went wrong";

  return (
    <span
      className={
        props.showSignifier ? classes.signifierContainer : classes.hidden
      }
      onAnimationEnd={() => props.setShowSignifier(false)}
    >
      <Card
        className={props.showSignifier ? classes.root : classes.hidden}
        variant="outlined"
      >
        <CardContent className={classes.root}>
          <span className={classes.title}>{signifierMessage}</span>
        </CardContent>
      </Card>
    </span>
  );
}
